import { render, staticRenderFns } from "./Information.vue?vue&type=template&id=59132aa0&scoped=true&"
import script from "./Information.vue?vue&type=script&lang=ts&"
export * from "./Information.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59132aa0",
  null
  
)

export default component.exports